/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="76px" height="78px" viewBox="0 0 76 78" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <title>Shield With Plus Sign</title>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <g id="Client-Bene-LP" transform="translate(-682.000000, -162.000000)" strokeWidth="2.5">
            <g id="Group" transform="translate(653.000000, 139.000000)">
              <g id="Group-11" transform="translate(30.690323, 24.400000)">
                <path d="M45.2621742,69.37224 C41.8922903,71.32344 38.0019677,73.06824 33.5125355,74.56024 C3.39798065,64.54904 0.219154839,43.18504 0.21656129,23.95704 L0.21656129,11.80664 C13.6814,11.43464 24.4714258,7.70184 33.5125355,0.20024 C42.5545097,7.70184 53.3454,11.43464 66.8102387,11.80664 L66.8102387,23.95704 C66.8102387,24.91944 66.8050516,25.89144 66.7523161,27.66984" id="Stroke-1" stroke="#FFFFFF"/>
                <circle xmlns="http://www.w3.org/2000/svg" id="Oval" stroke="#FFB81C" strokeWidth="2.5" cx="53" cy="47" r="18"/>
                <polyline id="Stroke-9" stroke="#FFFFFF" points="65,47 53,47 53,36 53,47 53,59 53,47 41, 47"/>
              </g>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithPlusSignIcon';

export default Icon;
